import { OTPInput, OTPInputContext } from 'input-otp';
import type { ElementRef, ReactNode } from 'react';
import { forwardRef, useContext } from 'react';

import * as styles from './otp-code-input.css';

export interface OtpCodeInputProps {
  value: string;
  onChange: (value: string) => void;
  onComplete?: (value: string) => void;
  disabled?: boolean;
  autoFocus?: boolean;
  testId?: string;
}

export const OtpCodeInput = forwardRef<
  ElementRef<typeof OTPInput>,
  OtpCodeInputProps
>(function OtpCodeInput(
  { value, onChange, onComplete, disabled, autoFocus, testId },
  ref
) {
  return (
    <OTPInput
      ref={ref}
      maxLength={6}
      value={value}
      onChange={onChange}
      onComplete={onComplete}
      disabled={disabled}
      autoFocus={autoFocus}
      data-testid={testId}
      containerClassName={styles.container}
    >
      <OtpGroup>
        <OtpSlot index={0} />
        <OtpSlot index={1} />
        <OtpSlot index={2} />
      </OtpGroup>
      <div className={styles.separator}>.</div>
      <OtpGroup>
        <OtpSlot index={3} />
        <OtpSlot index={4} />
        <OtpSlot index={5} />
      </OtpGroup>
    </OTPInput>
  );
});

const OtpGroup = ({ children }: { children: ReactNode }) => {
  return <div className={styles.group}>{children}</div>;
};

const OtpSlot = ({ index }: { index: number }) => {
  const inputOTPContext = useContext(OTPInputContext);
  const { char, hasFakeCaret, isActive } = inputOTPContext.slots[index];

  return (
    <div className={styles.slot} data-active={isActive || undefined}>
      {char}
      {hasFakeCaret && <div className={styles.fakeCaret} />}
    </div>
  );
};
